import { StoreAction, XmAction } from 'store/actions';
import { PaymentSummary } from './models';

export function paymentSummaryReducer(state: PaymentSummary[] = [], action: XmAction<PaymentSummary>): PaymentSummary[] {
    switch (action.type) {
        case StoreAction.GET_PAYMENT_SUMMARY:
            return [ ...state, action.payload ];
        case StoreAction.CLEAR_PAYMENT_SUMMARY:
            return undefined;
        default:
            return state;
    }
}
